import React, { useState, useRef, useEffect } from 'react';
import { Shield, Bell, Trophy } from 'lucide-react';
import NotificationCenter from '../NotificationCenter';

const Navbar = ({ 
  user, 
  isAdmin, 
  onSearch, 
  onLogo, 
  onLogin, 
  onShowFAQ, 
  onAdmin,
  notifications = [],
  unreadCount = 0,
  onMarkAsRead,
  onMarkAllAsRead,
  onNavigate,
  pushNotifications
}) => {

  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [showNotifications]);


  return (
    <nav className="glass" style={{ margin: '1rem', position: 'sticky', top: '1rem', zIndex: 100, borderRadius: '1rem' }}>
      <div className="container" style={{ height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div onClick={onLogo} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '0.4rem' }}>
          <img src="/favicon.png" style={{ height: '44px', width: 'auto' }} alt="Logo" />
          <span className="desktop-only" style={{ fontSize: '1.4rem', fontWeight: 900, letterSpacing: '0px' }}>
            CITA<span style={{ color: 'var(--primary)' }}>DOS</span>
          </span>
        </div>

        <div style={{ display: 'flex', gap: 'clamp(0.8rem, 3vw, 1.5rem)', alignItems: 'center' }} className="nav-links">
          <button className="desktop-only" onClick={onShowFAQ} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '0.9rem', cursor: 'pointer' }}>FAQ</button>
          
          {isAdmin && (
            <button 
              className="desktop-only" 
              onClick={onAdmin} 
              style={{ background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.2)', color: '#ef4444', padding: '0.6rem', borderRadius: '0.8rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              <Shield size={18} />
              <span style={{ fontSize: '0.8rem', fontWeight: 700 }}>ADMIN</span>
            </button>
          )}


          {user && (
            <div ref={notificationRef} style={{ position: 'relative' }}>
              <button 
                onClick={() => setShowNotifications(!showNotifications)}
                style={{ 
                  background: 'rgba(255,255,255,0.05)', 
                  border: '1px solid rgba(255,255,255,0.1)', 
                  color: 'white', 
                  padding: '0.6rem', 
                  borderRadius: '0.8rem', 
                  cursor: 'pointer', 
                  display: 'flex', 
                  alignItems: 'center',
                  position: 'relative'
                }}
              >
                <Bell size={18} />
                {unreadCount > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    background: '#ff4444',
                    color: 'white',
                    fontSize: '10px',
                    width: '18px',
                    height: '18px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    boxShadow: '0 0 10px rgba(255,68,68,0.5)'
                  }}>
                    {unreadCount}
                  </span>
                )}
              </button>
              
              {showNotifications && (
                <NotificationCenter 
                  notifications={notifications}
                  unreadCount={unreadCount}
                  onMarkAsRead={onMarkAsRead}
                  onMarkAllAsRead={onMarkAllAsRead}
                  onClose={() => setShowNotifications(false)}
                  onNavigate={onNavigate}
                  pushNotifications={pushNotifications}
                />

              )}
            </div>
          )}

          {user && (
            <button 
              onClick={() => onLogo('cards')} 
              style={{ 
                background: 'rgba(255,255,255,0.05)', 
                border: '1px solid rgba(255,255,255,0.1)', 
                color: 'white', 
                padding: '0.6rem', 
                borderRadius: '0.8rem', 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                transition: 'all 0.2s'
              }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--primary)'}
              onMouseLeave={e => e.currentTarget.style.color = 'white'}
              title="Mis Cartas"
            >
              <Trophy size={18} />
              <span className="desktop-only" style={{ fontWeight: 600 }}>Mis Cartas</span>
            </button>
          )}

          <button className="btn-primary desktop-only" onClick={onSearch} style={{ padding: '0.6rem 1.2rem', fontSize: '0.9rem' }}>Armar Partido</button>
          
          {user ? (
            <div 
              onClick={() => onLogo('profile')} 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '0.75rem', 
                cursor: 'pointer',
                background: 'rgba(255,255,255,0.05)',
                padding: '0.4rem 0.8rem',
                borderRadius: '99rem',
                border: '1px solid rgba(255,255,255,0.1)'
              }}
            >
              <img 
                src={user.user_metadata?.avatar_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${user.email}`} 
                style={{ width: '32px', height: '32px', borderRadius: '50%', border: '2px solid var(--primary)' }} 
                alt="Avatar"
              />
              <span style={{ fontWeight: 600, fontSize: '0.9rem' }} className="desktop-only">{user.user_metadata?.full_name?.split(' ')[0] || 'Mi cuenta'}</span>
            </div>
          ) : (
            <button className="btn-outline" onClick={onLogin} style={{ padding: '0.6rem 1.2rem', fontSize: '0.9rem' }}>Ingresar</button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
